export default function VisitIcon() {
  return (
    <span className="w-6 flex justify-center">
      <svg
        width="20"
        height="18"
        viewBox="0 0 20 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13 3.69495L19 2.19495V15.6949L13 17.1949M13 3.69495L7 0.694946M13 3.69495V17.1949M13 17.1949L7 14.1949M7 14.1949V0.694946M7 14.1949L1 15.6949V2.19495L7 0.694946"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
